export default {
  SET_STATE: 'roles/SET_STATE',
  FETCH_ROLES: 'roles/FETCH_ROLES',
  CREATE_ROLES: 'roles/CREATE_ROLES',
  FETCH_SINGLE_ROLE: 'roles/FETCH_SINGLE_ROLE',
  UPDATE_ROLE: 'roles/UPDATE_ROLE',
}
